import './index.scss'
import React from 'react'
import Content from '../../../components/content'

// 客户说
const Says = (props) => {
  // 切换显示 tab
  function switchTabContent(e) {
    const container = $(e.target).parents('.site-section')
    container.find('.tab-content')
      .removeClass('active').end()
      .find(`[data-tab=${$(e.target).closest('li').data('display')}]`).addClass('active')
    container.find('.tab-navs').find('.active').removeClass('active')
    $(e.target).closest('li').addClass('active')
    e.stopPropagation()
    return false
  }
  //
  return [{
    uid: 'says-1',
    html:(
      <div className="section-says">
        <div className="container">
          <h2 className="text-center section-title">{props.title.content}</h2>

          <div className="tab-contents-wrapper">
            {props.list.items.map((item, index) =>
              <div data-tab={index}
                   className={"tab-content"+(index === 0 ? ' active' : '')}
                   key={index}>
                <div>
                  <div className="tab-content-des">
                    <div>{item.description.content}</div>
                  </div>
                  <div className="tab-content-title">
                    {item.title.content}
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <ul className="list-inline tab-navs">
            {props.list.items.map((item, index) =>
              <li key={index}
                  className={index === 0 ? 'active' : ''}
                  data-display={index}
                  onMouseEnter={(e) => switchTabContent(e) }>
                <img src={item.media.src} />
              </li>
            )}
          </ul>
        </div>
      </div>
    )
  }]
}

export default Says


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/says/index.js